import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ExploreIcon from '@material-ui/icons/Explore';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const useStyles = makeStyles(theme => ({
  live: {
    fontSize: '0.7rem',
    backgroundColor: '#dc004e!important',
    color: '#fff!important'
  },
  replay: {
    fontSize: '0.7rem',
    // backgroundColor: '#f57c00!important',
    // color: '#fff!important'
  },
  vod: {
    fontSize: '0.7rem',
    backgroundColor: '#fff!important',
    color: '#333!important'
  },
  pending: {
    fontSize: '0.7rem',
    backgroundColor: '#eec500!important',
    color: '#222!important'
  },
  upcoming: {
    fontSize: '0.7rem',
    backgroundColor: '#e7e7e8!important',
    color: '#999!important'
  },
  expired: {
    fontSize: '0.7rem',
    backgroundColor: 'rgba(255,255,255,0.5)!important',
    color: '#333!important'
  },
  explore: {
    fontSize: '0.7rem',
  },
}));

export default (props) => {
  const classes = useStyles();
  return (
    <>
    { props.config.isLive &&
      <Button size="small" variant="contained" color="secondary" className={classes.live} disableElevation startIcon={<PlayCircleOutlineIcon />} onClick={e => props.handleClick()}>watch live</Button>
    }
    { props.config.isReplay &&
      <Button size="small" variant="contained" color="secondary" className={classes.replay} disableElevation startIcon={<PlayCircleOutlineIcon />} onClick={e => props.handleClick()}>watch replay</Button>
    }
    { props.config.isVoD &&
      <Button size="small" variant="contained" color="secondary" className={classes.vod} disableElevation startIcon={<PlayCircleOutlineIcon />} onClick={e => props.handleClick()}>watch now</Button>
    }
    { props.config.isUpcoming &&
      // <Button size="small" variant="contained" color="secondary" className={classes.upcoming} disableElevation startIcon={<VideoLibraryOutlinedIcon />} onClick={e => props.handleClick()}>upcoming</Button>
      <Button size="small" variant="contained" color="secondary" className={classes.explore} disableElevation startIcon={<ExploreIcon />} endIcon={<ArrowRightIcon />} onClick={e => props.handleClick()}>explore</Button>
    }
    { props.config.isPending &&
      <Button size="small" variant="contained" color="secondary" className={classes.pending} disableElevation startIcon={<VideoLibraryOutlinedIcon />} onClick={e => props.handleClick()}>pending</Button>
    }
    { props.config.isExpired &&
      <Button size="small" variant="contained" color="secondary" className={classes.expired} disableElevation startIcon={<ErrorOutlineIcon />} >expired</Button>
    }
    </>
  );
}